import Config from '@/config/index'

const getCurrentDomainFromConfig = (url = Config.appHostUrl) => {
  if (!TypeChecker.isString(url)) {
    return ''
  }

  return url.replace(/(^(http|https):\/\/|:[0-9]+$)/g, '')
}

export { getCurrentDomainFromConfig }
